export default "__VITE_ASSET__BbFPYSxC__"